import HeadFormSignUp from './HeadFormSignUp';
export default HeadFormSignUp;
